import { JsonApiLink } from '@/api/json-api.types';
import { CAEndpointsState, ENDPOINT_GETTER, ENDPOINT_MUTATION_AGREGAR } from './endpoints.types';

// Estado inicial del mapeo de los endpoints
const state: CAEndpointsState = {
  endpoints_map: new Map<string, JsonApiLink>() // Inicializamos el mapeo de endpoints
};

// Getters de los endpoints
const getters = {

  /**
   * Metodo que retorna el endpoint cuya key coincide con la pasada por parametro buscandola en el mapeo de endpoints
   * 
   * @param state
   * @param key_endpoint string con la key del endpoint
   * 
   * @returns href del endpoint cuya key coincide con la pasada por parametro, undefined en caso que la key no este presente
   */
  [ENDPOINT_GETTER]: (state: CAEndpointsState) => (key_endpoint: string) => {
    return state.endpoints_map.get(key_endpoint)?.href;
  }
};

//Mutations de los endpoints
const mutations = {

  /**
   * Metodo que setea un nuevo elemento en el mapeo de endpoints
   * 
   *  @param state
    * @param payload El payload tiene un arreglo con dos elementos (primer elemento: key del endpoint, segundo elemento: JsonApiLink de esta menera tenemos el metodo y el href del endpoint)
   */
  [ENDPOINT_MUTATION_AGREGAR](state: CAEndpointsState, payload) {
    state.endpoints_map.set(payload[0], payload[1]);
  }
};

export default {
  state,
  getters,
  mutations
};